import React from 'react';
import PropTypes from "prop-types";
import styles from './index.module.scss';

class AvatarItem extends React.Component {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        style: {},
        label: '',
    };

    static propTypes = {
        style: PropTypes.object, // 标签样式
        label: PropTypes.string, // 标签文案
    };

    componentDidMount() {
    }


    render() {
        const {
            style,
            label
        } = this.props;

        return (
            <div className={styles.label} style={style}>{label}</div>
        )
    }
}
export default AvatarItem;